import { render, staticRenderFns } from "./LaboratoryBranches.vue?vue&type=template&id=e7e57802&scoped=true"
import script from "./LaboratoryBranches.vue?vue&type=script&lang=js"
export * from "./LaboratoryBranches.vue?vue&type=script&lang=js"
import style0 from "./LaboratoryBranches.vue?vue&type=style&index=0&id=e7e57802&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7e57802",
  null
  
)

export default component.exports